import { fetchProjects } from '../../services';
import {
  ACTIVE_PROJECT,
  ACTIVE_PROJECT_TAB,
  FETCH_PROJECTS_FAILURE,
  FETCH_PROJECTS_START,
  FETCH_PROJECTS_SUCCESS,
  PROJECT_DOCS,
  TITLE_STATE,
  MAP_VIEW,
} from './types';

export const mapViewDisplay = (payload) => async (dispatch) => {
  try {
    dispatch({ type: MAP_VIEW, payload });
  } catch (error) {
    console.log(error);
  }
};

export const getAllProjects = () => async (dispatch) => {
  try {
    dispatch({ type: FETCH_PROJECTS_START });
    const response = await fetchProjects();
    dispatch({ type: FETCH_PROJECTS_SUCCESS, payload: response?.data });
  } catch (error) {
    dispatch({ type: FETCH_PROJECTS_FAILURE });
  }
};

export const setActiveProject = (project) => (dispatch) => {
  dispatch({ type: ACTIVE_PROJECT, payload: project });
};

export const setActiveProjectTab = (tabKey) => (dispatch) => {
  dispatch({ type: ACTIVE_PROJECT_TAB, payload: tabKey });
};

export const setProjectDocs = (data) => (dispatch) => {
  dispatch({ type: PROJECT_DOCS, payload: data });
};

export const setTitleValue = (data) => (dispatch) => {
  dispatch({ type: TITLE_STATE, payload: data });
};
